import { Modal } from '@/components';

import CodeConfirm from './CodeConfirm';

type CodeConfirmModalProps = {
  method: 'email' | 'sms';
  onClose: () => void;
  onConfirmed?: (recoveryCodes: string[]) => void | Promise<void>;
};

/** Modal host for {@link CodeConfirm} — the email/SMS counterpart to TotpEnrollModal. */
const CodeConfirmModal = ({ method, onClose, onConfirmed }: CodeConfirmModalProps) => (
  <Modal open onClose={onClose}>
    <CodeConfirm method={method} onConfirmed={onConfirmed} onDone={onClose} />
  </Modal>
);

export default CodeConfirmModal;
